import { GetterTree } from "vuex";
import { RootState, VenueAdminzoneState } from "@/types/store/adminzone";
import { VenueData } from "@/types";

export const getters: GetterTree<VenueAdminzoneState, RootState> = {
  GET_VENUES: (state): Array<VenueData> => state.venues,
  GET_ALL_VENUES: (state): Array<VenueData> => state.allVenues
}
